import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, SectionHead } from "./Reveal";

const before = ["Server im Abstellraum, Wissen in einem Kopf", "Lizenzen, Verträge und Passwörter ohne Dokumentation", "Räume aus den 90ern, die junge Fachkräfte abschrecken", "Käufer kalkulieren Risiken – und drücken den Preis"];
const after = ["Dokumentierte, sichere und skalierbare IT", "Klare Prozesse, die ohne Inhaber funktionieren", "Arbeitswelten, in denen Nachfolger gern ankommen", "Ein Unternehmen, das sich selbst gut verkauft"];

const List = ({ items, tone, testid }) => (
  <ul className="mt-8 space-y-0" data-testid={testid}>
    {items.map((t, i) => (
      <Reveal key={t} delay={i * 0.08}>
        <li className={`flex gap-5 border-t py-5 text-base md:text-lg ${tone === "dark" ? "border-white/15 text-[var(--stone)]" : "border-[var(--line)] text-[var(--ink-2)]"}`}>
          <span className={`font-mono-d pt-1 text-xs ${tone === "dark" ? "text-[#E3A68F]" : "text-[var(--ink-2)]"}`}>0{i + 1}</span>
          {t}
        </li>
      </Reveal>
    ))}
  </ul>
);

export const Problem = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="ansatz" ref={ref} data-testid="problem-section" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-40">
      <SectionHead
        id="ansatz"
        eyebrow="01 — Der Ansatz"
        title={["Käufer bezahlen Zukunft,", <span key="i" className="italic text-[var(--clay)]">nicht Vergangenheit.</span>]}
        intro="Bei vielen Nachfolgen im Mittelstand entscheiden nicht nur Umsatz und Kunden über den Preis. Veraltete IT und unattraktive Arbeitsplätze sind Risiken, die jeder Käufer einpreist. Wir verwandeln sie in Argumente."
      />
      <div className="mt-20 grid gap-6 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="eyebrow">Heute</p>
          <List items={before} testid="problem-before-list" />
        </div>
        <div className="relative overflow-hidden bg-[var(--ink)] p-8 sm:p-12 lg:col-span-7">
          <motion.img style={{ y }} src="/img/office.jpg" alt="" className="absolute inset-0 h-[120%] w-full object-cover opacity-25" />
          <div className="relative">
            <p className="eyebrow !text-[#E3A68F]">Nach Aufbruchwerk</p>
            <List items={after} tone="dark" testid="problem-after-list" />
          </div>
        </div>
      </div>
    </section>
  );
};
